// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1uisL","title":"AfterFrontImage_title__19HVK"};